import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import { PatientCareCenterNoteObjectiveNeuroToneDetails } from './ToneDetails';
import styles from './Common.module.css';
import { AddButton, DBTextArea } from '_components';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';

class PatientCareCenterNoteObjectiveNeuroTone extends React.Component {

    addMuscleGroup() {
        this.props.addChildRow(this.props.noteId, 'PTOBJECTIVEPEDSTONE', 'OT', 'OTOPNO', this.props.opno);
    }

    render() {
            return (
                <PatientCareCenterNoteSection id='neuro_tone' name='Tone' level={2} noChildPadding={true}>
                    <div className={styles.row}>
                      <div className={styles.add_button}>
                        <AddButton size='extra-small' title='Muscle Group' onClick={() => this.addMuscleGroup()} />
                      </div>
                      <span>
                        <div className={styles.column_header}>Muscle Group</div>
                            <div className={styles.column_header}>Score</div>
                        </span>
                    </div>
                   
                    {Object.keys(this.props.entries)
                        .map(key => {
                            const result = this.props.entries[key];
                            return (
                                 <PatientCareCenterNoteObjectiveNeuroToneDetails key={result.OTNO} id={result.OTNO} />
                            )
                        })
                    }
                    <br/>
                     <div className={styles.label}>
                        <span><b>Comments</b></span>
                     </div>
                     <div className={styles.row}>
                     <DBTextArea
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEPEDS'
                        entityKeyColumn='OPNO'
                        entityKeyValue={this.props.opno}
                        field='OPTOCOMMENTS'
                        className={styles.textarea}
                     />
                     </div>

                </PatientCareCenterNoteSection>
            );
       
    }

}

function mapDispatchToProps(dispatch) {
    return {
        addChildRow: bindActionCreators(noteActions.addChildRow, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);

    let opno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEPEDS)
        .find(key => (state.entities.notes.PTOBJECTIVEPEDS[key].OPEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEPEDS[key].OPNTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        entries: Object.keys(state.entities.notes.PTOBJECTIVEPEDSTONE)
        .filter(key => { return state.entities.notes.PTOBJECTIVEPEDSTONE[key].OTOPNO === opno })
        .sort((a, b) => state.entities.notes.PTOBJECTIVEPEDSTONE[a].OTNO - state.entities.notes.PTOBJECTIVEPEDSTONE[b].OTNO)
        .map(key => state.entities.notes.PTOBJECTIVEPEDSTONE[key]),
        opno
    };
}

const connectedPatientCareCenterNoteObjectiveNeuroTone = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteObjectiveNeuroTone);
export { connectedPatientCareCenterNoteObjectiveNeuroTone as PatientCareCenterNoteObjectiveNeuroTone };

